<template>
    <DCard
        padding
    >
        <Form
            :country="country"
            :state="state"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/Countries/States/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    country: {
        type: Object,
        default: () => ({})
    },
    state: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const submitData = (form) => {
    form.put(route('settings.countries.states.update', { country: props.country.country_code, state: props.state.id }))
}
</script>
